import { createContext, useContext, useEffect, useState } from "react";
import { basePath } from "../components/config";
import { useLocation, useSearchParams } from "react-router-dom";
import { useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { useAuth } from "./auth";
import Cookies from "js-cookie";

export const OrderStateContext = createContext(null);
export const OrderUpdateContext = createContext(null);

export function OrderProvider({ children }) {
  const [formState, setFormState] = useState(null);
  const [orders, setOrders] = useState(null);
  const [orderdata, setOrderData] = useState(null);
  const [isAddCoreFormOpen, setAddCoreFormOpen] = useState(false);
  const [isPaperSizeFormOpen, setPaperSizeFormOpen] = useState(false);
  const [isPaperTypeFormOpen, setPaperTypeFormOpen] = useState(false);
  const [isAddLabelFormOpen, setIsAddLabelFormOpen] = useState(false);
  const [isAddUpFormOpen, setIsAddUpFormOpen] = useState(false);

  const [limit, setLimit] = useState(Cookies.get("limit") || 10);

  let { pathname } = useLocation();

  const [isHistoryPage, setIsHistoryPage] = useState(
    pathname?.includes("history")
  );
  const [isFilterPage, setIsFilterPage] = useState(
    pathname?.includes("-filter/")
  );

  const { pageNo } = useParams();

  const [{ activeUser }] = useAuth();
  const [searchParams] = useSearchParams();

  const payload = JSON.stringify({
    brand_name: searchParams.get("brand_name"),
    party_name: searchParams.get("party_name"),
    order_type: searchParams.get("order_type"),
    size: searchParams.get("size"),
    teeth: searchParams.get("teeth"),
    paper_type: searchParams.get("paper_type"),
  });

  useEffect(() => {
    setIsFilterPage(pathname?.includes("-filter/"));
    setIsHistoryPage(pathname?.includes("history"));
  }, [pathname]);

  useEffect(() => {
    (async () => {
      if (pathname?.includes("-filter/")) {
        try {
          setOrders(null);
          const res = await fetch(
            basePath +
              (pathname?.includes("history")
                ? `getFilteredHistory?page=${pageNo}&&limit=${limit}`
                : `getFilteredOrders?page=${pageNo}&&limit=${limit}`),
            {
              method: "post",
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${activeUser?.remember_token}`,
              },
              body: payload,
            }
          );
          const data = await res.json();

          if (res.status === 401) {
            toast.error(data.message);
            document.cookie =
              "user=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
            return 0;
          }

          if (data.status) {
            setOrders(JSON.parse(data.data));
            setOrderData({
              labels: JSON.parse(data.labels),
              cores: JSON.parse(data.cores),
              ups: JSON.parse(data.ups),
              papers: JSON.parse(data.papers),
              colors: JSON.parse(data.colors),
              paper_size: JSON.parse(data.paper_size),
              teeths: data.teeths,
            });
          } else {
            setOrders(null);
          }
        } catch (error) {
          setOrders(null);
          console.error("getOrderData:: api calling fail =>", error);
        }
      } else {
        try {
          setOrders(null);
          const res = await fetch(
            basePath +
              (pathname?.includes("history")
                ? `getOrderHistory?page=${pageNo}&&limit=${limit}`
                : `getOrders?page=${pageNo}&&limit=${limit}`),
            {
              method: "post",
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${activeUser?.remember_token}`,
              },
            }
          );
          const data = await res.json();

          if (res.status === 401) {
            toast.error(data.message);
            document.cookie =
              "user=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
            return 0;
          }

          if (data.status) {
            setOrders(JSON.parse(data.data));
            setOrderData({
              labels: JSON.parse(data.labels),
              cores: JSON.parse(data.cores),
              ups: JSON.parse(data.ups),
              papers: JSON.parse(data.papers),
              colors: JSON.parse(data.colors),
              paper_size: JSON.parse(data.paper_size),
              teeths: data.teeths,
            });
          } else {
            setOrders(null);
          }
        } catch (error) {
          setOrders(null);
          console.error("getOrderData:: api calling fail =>", error);
        }
      }
    })();
  }, [pathname, payload, limit]);

  const state = {
    orders,
    formState,
    orderdata,
    isHistoryPage,
    isFilterPage,
    isAddCoreFormOpen,
    isPaperSizeFormOpen,
    isPaperTypeFormOpen,
    isAddLabelFormOpen,
    isAddUpFormOpen,
    limit,
  };
  const updateFns = {
    setOrders,
    setFormState,
    setOrderData,
    setAddCoreFormOpen,
    setPaperSizeFormOpen,
    setPaperTypeFormOpen,
    setIsAddLabelFormOpen,
    setIsAddUpFormOpen,
    setLimit,
  };

  return (
    <OrderStateContext.Provider value={state}>
      <OrderUpdateContext.Provider value={updateFns}>
        {children}
      </OrderUpdateContext.Provider>
    </OrderStateContext.Provider>
  );
}

export function useOrder() {
  const state = useContext(OrderStateContext);
  const updateFns = useContext(OrderUpdateContext);
  return [state, updateFns];
}
